import React, {
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Box,
  Button,
  Chip,
  Divider,
  Grid,
  IconButton,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import ReactQuill, { Quill } from "react-quill-new";
import QuillTableBetter from "quill-table-better";
import "react-quill-new/dist/quill.snow.css";
import "quill-table-better/dist/quill-table-better.css";
import { Add, Delete } from "@mui/icons-material";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import CategoryIcon from "@mui/icons-material/Category";
import AddchartIcon from "@mui/icons-material/Addchart";
import axios from "axios";
import { BASE_URL } from "../../constants";
import ScienceIcon from "@mui/icons-material/Science";
import BiotechIcon from "@mui/icons-material/Biotech";
import DirtyLensIcon from "@mui/icons-material/DirtyLens";
import { useRecoilValue } from "recoil";
import { authState } from "../../recoil/authAtom";

Quill.register({ "modules/table-better": QuillTableBetter }, true);
const MicroBiology = ({
  test,
  investigation,
  setOpenModal,
  selectedTest,
  handleDisableTest,
  disableLoading,
}) => {
  const user = useRecoilValue(authState);
  const [microBiologyInvestigations, setMicrobiologyInvestigations] = useState({
    organism: [],
    compound: [],
  });
  const [loading, setLoading] = useState(false);

  const quillRefMicro = useRef(null);
  const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: 1 }, { header: 2 }], // custom button values
          ["bold", "italic", "underline", "strike"], // toggled buttons
          ["link", "image"],
          [{ list: "bullet" }],
          [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
          [{ direction: "rtl" }], // text direction
          [{ size: ["small", false, "large", "huge"] }], // custom dropdown
          [{ color: [] }, { background: [] }], // dropdown with defaults from theme
          [{ font: [] }],
          [{ align: [] }],
          // ['tableUI']
          ["table-better"], // Add table tool
        ],
      },
      table: false,
      "table-better": {
        language: "en_US",
        menus: [
          "column",
          "row",
          "merge",
          "table",
          "cell",
          "wrap",
          "copy",
          "delete",
        ],
        toolbarTable: true,
      },
      keyboard: {
        bindings: QuillTableBetter.keyboardBindings,
      },
    }),
    [],
  );

  useEffect(() => {
    if (investigation) {
      setMicrobiologyInvestigations(investigation);
    }
  }, [investigation]);

  // ===== Organism handlers =====
  const handleAddOrganism = () => {
    // if (microBiologyInvestigations.organism.length >= 6) return;
    setMicrobiologyInvestigations((prev) => ({
      ...prev,
      organism: [...prev.organism, ""],
    }));
  };

  const handleRemoveOrganism = (indexToRemove) => {
    setMicrobiologyInvestigations((prev) => ({
      ...prev,
      organism: prev.organism.filter((_, i) => i !== indexToRemove),
    }));
  };

  const handleOrganismChange = (index, value) => {
    const updated = [...microBiologyInvestigations.organism];
    updated[index] = value;
    setMicrobiologyInvestigations((prev) => ({
      ...prev,
      organism: updated,
    }));
  };

  // ===== Compounds handlers =====
  const handleAddCompound = () => {
    // if (microBiologyInvestigations.compounds.length >= 6) return;
    setMicrobiologyInvestigations((prev) => ({
      ...prev,
      compound: [...prev.compound, ""],
    }));
  };

  const handleRemoveCompound = (indexToRemove) => {
    setMicrobiologyInvestigations((prev) => ({
      ...prev,
      compound: prev.compound.filter((_, i) => i !== indexToRemove),
    }));
  };

  const handleCompoundChange = (index, value) => {
    const updated = [...microBiologyInvestigations.compound];
    updated[index] = value;
    setMicrobiologyInvestigations((prev) => ({
      ...prev,
      compound: updated,
    }));
  };

  const handleChangeTest = (value) => {
    setMicrobiologyInvestigations((prev) => ({
      ...prev,
      text: value,
    }));
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${BASE_URL}api/user/microbiology/create-microbiology-investigation/${test._id}`,
        microBiologyInvestigations,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const resp = response.data;
      alert(resp.message);
      window.location.reload();
    } catch (error) {
      console.error("Error submitting data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${BASE_URL}api/user/microbiology/update-microbiology-investigation/${test._id}`,
        microBiologyInvestigations,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const resp = response.data;
      alert(resp.message);
      // window.location.reload();
    } catch (error) {
      console.error("Error submitting data:", error);
    } finally {
      setLoading(false);
    }
  };

  useLayoutEffect(() => {
    if (!quillRefMicro.current) return;
    if (!microBiologyInvestigations?.text) return;

    const editor = quillRefMicro.current.getEditor();
    const html = microBiologyInvestigations?.text;
    const delta = editor.clipboard.convert({ html });
    const [range] = editor.selection.getRange();
    editor.setContents([], Quill.sources.SILENT);
    editor.updateContents(delta, Quill.sources.USER);
    editor.setSelection(
      delta.length() - (range?.length || 0),
      Quill.sources.SILENT,
    );
    editor.scrollSelectionIntoView();
  }, [microBiologyInvestigations?.text]);
  console.log("MMM", microBiologyInvestigations);
  return (
    <Paper sx={{ mt: 3, p: 3 }}>
      {/* Test Info */}
      <div>
        <Chip avatar={<AddchartIcon />} label={test?.testName} />
        <Chip avatar={<CategoryIcon />} label={test?.testCat} sx={{ mx: 1 }} />
        <Chip avatar={<CurrencyRupeeIcon />} label={test?.testPrice} />
        {user?._doc?.permissions?.testHeaderManagement?.edit && (
          <>
            <Button
              variant="contained"
              size="small"
              color="success"
              style={{ fontSize: "10px", margin: "0px 3px" }}
              onClick={() => setOpenModal(true)}
            >
              Edit Header
            </Button>

            {selectedTest?.isEnabled ? (
              <Button
                variant="outlined"
                color="error"
                size="small"
                style={{ fontSize: "10px" }}
                onClick={() => handleDisableTest()}
                disabled={disableLoading}
              >
                {disableLoading ? "Disabling..." : "Disable Test"}
              </Button>
            ) : (
              <Button
                variant="outlined"
                color="success"
                size="small"
                style={{ fontSize: "10px" }}
                onClick={() => handleDisableTest()}
                disabled={disableLoading}
              >
                {disableLoading ? "Enabling..." : "Enable Test"}
              </Button>
            )}
          </>
        )}
      </div>

      {/* <Typography variant="h6" mt={2}>
        Organism
      </Typography> */}
      <Chip
        icon={<DirtyLensIcon />}
        label="Organism"
        // size="small"
        color="secondary"
        variant="outlined"
        sx={{ my: 2 }}
      />
      <Grid container spacing={2}>
        {microBiologyInvestigations.organism.map((value, index) => (
          <Grid item xs={6} key={`organism-${index}`}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <TextField
                fullWidth
                required
                label={`Organism ${index + 1}`}
                value={value}
                onChange={(e) => handleOrganismChange(index, e.target.value)}
                variant="outlined"
                size="small"
              />
              <div
                style={{
                  backgroundColor: "#fff0f3",
                  marginLeft: "5px",
                  padding: "1px",
                  borderRadius: "5px",
                }}
              >
                <IconButton
                  onClick={() => handleRemoveOrganism(index)}
                  //   disabled={microBiologyInvestigations?.organism?.length <= 1}
                  sx={{ color: "#ff4d6d" }}
                >
                  <Delete />
                </IconButton>
              </div>
            </Box>
          </Grid>
        ))}
      </Grid>
      <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
        <Button
          variant="contained"
          startIcon={<Add />}
          color="secondary"
          size="small"
          onClick={handleAddOrganism}
          //   disabled={microBiologyInvestigations.organism.length >= 6}
          //   sx={{ width: "25%" }}
        >
          Organism
        </Button>
      </Box>

      {/* Compound Inputs */}
      <Divider sx={{ mt: 2 }} />
      <div style={{ backgroundColor: "white" }}>
        {/* <Typography variant="h6" mt={4}>
        Compounds
      </Typography> */}
        <Chip
          icon={<ScienceIcon />}
          label="Compound"
          //   size="small"
          color="info"
          variant="outlined"
          sx={{ my: 2 }}
        />
        <Grid container spacing={2}>
          {microBiologyInvestigations.compound.map((value, index) => (
            <Grid item xs={6} key={`compound-${index}`}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <TextField
                  fullWidth
                  required
                  label={`Compound ${index + 1}`}
                  value={value}
                  onChange={(e) => handleCompoundChange(index, e.target.value)}
                  variant="outlined"
                  size="small"
                />
                <div
                  style={{
                    backgroundColor: "#fff0f3",
                    marginLeft: "5px",
                    padding: "1px",
                    borderRadius: "5px",
                  }}
                >
                  <IconButton
                    onClick={() => handleRemoveCompound(index)}
                    //   disabled={microBiologyInvestigations.compounds.length <= 1}
                    sx={{ color: "#ff4d6d" }}
                  >
                    <Delete />
                  </IconButton>
                </div>
              </Box>
            </Grid>
          ))}
        </Grid>

        {/* Buttons */}
        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
          <Button
            variant="contained"
            startIcon={<Add />}
            color="primary"
            onClick={handleAddCompound}
            size="small"
            //   disabled={microBiologyInvestigations.compounds.length >= 6}
            //   sx={{ width: "25%" }}
          >
            Compound
          </Button>
        </Box>
      </div>
      <Divider sx={{ my: 2 }} />
      {/* <ReactQuill
        value={microBiologyInvestigations?.text}
        onChange={(value) => handleChangeTest(value)}
        placeholder="Enter..."
        modules={{
          toolbar: toolbarOptions,
        }}
      /> */}
      <ReactQuill
        ref={quillRefMicro}
        theme="snow"
        modules={modules}
        placeholder="Enter..."
        onChange={(content) => handleChangeTest(content)}
      />
      <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
        <div></div>
        {investigation.organism.length === 0 &&
        investigation.compound.length === 0 &&
        investigation.text.length === 0 ? (
          <Button
            variant="contained"
            color="success"
            sx={{ width: "15%" }}
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Saving..." : "Save"}
          </Button>
        ) : (
          <Button
            variant="contained"
            color="warning"
            sx={{ width: "15%" }}
            onClick={handleUpdate}
            disabled={loading}
          >
            Update
          </Button>
        )}
      </Box>
    </Paper>
  );
};

export default MicroBiology;
